/**
 * @packageDocumentation
 * @module api.functional.auth
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
//================================================================
import type { IConnection } from "@nestia/fetcher";
import { PlainFetcher } from "@nestia/fetcher";

import type { AuthResponseDto } from "../../structures/AuthResponseDto";
import type { LoginDto } from "../../structures/LoginDto";

export * as me from "./me/index";
export * as instant_login from "./instant_login/index";
export * as signup from "./signup/index";
export * as verify_email from "./verify_email/index";
export * as change_password from "./change_password/index";
export * as reset_password from "./reset_password/index";
export * as resend_email_verification from "./resend_email_verification/index";

/**
 * @controller AuthController.login
 * @path POST /auth/login
 * @accessor api.functional.auth.login
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
export async function login(
  connection: IConnection,
  body: login.Body,
): Promise<login.Output> {
  return PlainFetcher.fetch(
    {
      ...connection,
      headers: {
        ...connection.headers,
        "Content-Type": "application/json",
      },
    },
    {
      ...login.METADATA,
      template: login.METADATA.path,
      path: login.path(),
    },
    body,
  );
}
export namespace login {
  export type Body = LoginDto;
  export type Output = AuthResponseDto;

  export const METADATA = {
    method: "POST",
    path: "/auth/login",
    request: {
      type: "application/json",
      encrypted: false,
    },
    response: {
      type: "application/json",
      encrypted: false,
    },
    status: 201,
  } as const;

  export const path = () => "/auth/login";
}
